import React from "react";
import { Button, DropdownButton, Dropdown, Form, Tabs, Tab, Modal, ToggleButton } from 'react-bootstrap';
import { Nav, ListGroup } from 'react-bootstrap';
import { context } from '../../AppContext';
import Flow from "../../flow/Flow";
import ConfigRaw from "./ConfigRaw";

export default class ConfigCombined extends React.Component {

    state = {
        raw: false
    };
    configTextAreaRef = React.createRef();

    constructor(props) {
        super(props);
        this.state.raw = props.raw === true ? true : false;
    }

    render() {
        return (
            <div className="ConfigCombined">
                { 
                    this.state.raw ? 
                        (
                            <ConfigRaw
                                detailScreen={ this.props.detailScreen }
                                data={ this.props.data }
                                fileName={ this.props.fileName }
                                textAreaRef={ this.props.textAreaRef }
                                extraButtons={[
                                    (
                                        <ToggleButton
                                            key="rawToggle"
                                            type="checkbox" value={ true }
                                            checked={ this.state.raw } 
                                            onChange={ () => {
                                                this.setState({ raw: !this.state.raw });
                                            }}
                                            variant={ this.state.raw ? "primary" : "secondary" }
                                        >Raw</ToggleButton>
                                    )
                                ]}
                            />
                        ) : (
                            <div>
                                <ToggleButton
                                    key="rawToggle"
                                    type="checkbox" value={ true }
                                    checked={ this.state.raw } 
                                    onChange={ () => {
                                        this.setState({ raw: !this.state.raw });
                                    }}
                                    variant={ this.state.raw ? "primary" : "secondary" }
                                >Raw</ToggleButton>
                                { this.props.visualView }
                            </div>
                        )
                    }
            </div>
        );
    }
}